import React, { useState, useEffect, useContext, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import {
   Box,
   Container,
   Grid,
   Button,
   Card,
   CardContent,
   CardHeader,
   Divider,
   TextField
} from '@material-ui/core'
import Loader from '../components/utils/Loader'
import { postPublicAPI } from '../api'
import getRandomString from '../utils/generateRandom'
// contexts
import { ToastContext } from '../contexts/Toast'

const discounts = [
   { value: 0, label: '0' },
   { value: 5, label: '5' },
   { value: 10, label: '10' },
   { value: 15, label: '15' },
   { value: 20, label: '20' },
   { value: 25, label: '25' },
   { value: 30, label: '30' },
   { value: 35, label: '35' },
   { value: 40, label: '40' },
   { value: 45, label: '45' },
   { value: 50, label: '50' },
   { value: 55, label: '55' },
   { value: 60, label: '60' },
   { value: 65, label: '65' },
   { value: 70, label: '70' },
   { value: 75, label: '75' },
   { value: 80, label: '80' },
   { value: 85, label: '85' },
   { value: 90, label: '90' },
   { value: 95, label: '95' },
   { value: 100, label: '100' }
]

const AddCustomer = props => {
   const navigate = useNavigate()
   const { setToasts } = useContext(ToastContext)
   let mounted = useRef(true)

   const [loading, setLoading] = useState(true)
   const [values, setValues] = useState({
      fName: '',
      lName: '',
      email: '',
      phone: '',
      company: '',
      address: '',
      discountValue: 0,
      password: getRandomString(8)
   })

   useEffect(() => {
      let mounted = true

      setTimeout(() => {
         if (!localStorage.auth_token || localStorage.user_type === 'customer') navigate('/login')
         mounted && setLoading(false)
      }, 1000)

      return () => (mounted = false)
   }, [navigate])

   const handleChange = event => {
      mounted.current &&
         setValues({
            ...values,
            [event.target.name]: event.target.value
         })
   }

   const addCustomer = async e => {
      e.preventDefault()

      if (!values.fName || !values.email || !values.phone) {
         if (!values.fName)
            setToasts({ type: 'error', messages: [{ msg: 'First Name is required' }] })

         if (!values.email)
            setToasts({ type: 'error', messages: [{ msg: 'Email address is required' }] })

         if (!values.phone)
            setToasts({ type: 'error', messages: [{ msg: 'Phone number is required' }] })

         return
      }

      let added = await postPublicAPI('/add-user', values)
      if (added?.success) {
         setToasts({ type: 'success', messages: [{ msg: 'Customer added successfully' }] })
      } else {
         setToasts({ type: 'error', messages: [{ msg: added?.errors[0]?.msg }] })
      }
      setValues({
         fName: '',
         lName: '',
         email: '',
         phone: '',
         company: '',
         address: '',
         discountValue: 0,
         password: ''
      })
      navigate('/app/dashboard')
   }

   return (
      <>
         <Helmet>
            <title>{loading ? 'Loading...' : 'Add Customer | The HosePod'}</title>
         </Helmet>
         <Box
            sx={{
               backgroundColor: 'background.default',
               minHeight: '100%',
               py: 3
            }}
         >
            <Container maxWidth='lg'>
               {loading ? (
                  <Loader />
               ) : (
                  <Grid container spacing={3}>
                     {/* <Grid item lg={2} md={6} xs={12}></Grid> */}
                     <Grid item lg={12} md={6} xs={12}>
                        <form autoComplete='off' noValidate {...props} onSubmit={addCustomer}>
                           <Card>
                              <CardHeader subheader='Enter Customer Details' title='Profile' />
                              <Divider />
                              <CardContent>
                                 <Grid container spacing={3}>
                                    <Grid item md={6} xs={12}>
                                       <TextField
                                          fullWidth
                                          label='First Name'
                                          name='fName'
                                          onChange={handleChange}
                                          required
                                          value={values.fName}
                                          variant='outlined'
                                       />
                                    </Grid>
                                    <Grid item md={6} xs={12}>
                                       <TextField
                                          fullWidth
                                          label='Last Name'
                                          name='lName'
                                          onChange={handleChange}
                                          value={values.lName}
                                          variant='outlined'
                                       />
                                    </Grid>
                                    <Grid item md={6} xs={12}>
                                       <TextField
                                          fullWidth
                                          label='Email Address'
                                          name='email'
                                          onChange={handleChange}
                                          required
                                          value={values.email}
                                          variant='outlined'
                                       />
                                    </Grid>
                                    <Grid item md={6} xs={12}>
                                       <TextField
                                          fullWidth
                                          label='Phone Number'
                                          name='phone'
                                          onChange={handleChange}
                                          required
                                          value={values.phone}
                                          variant='outlined'
                                       />
                                    </Grid>
                                    <Grid item md={6} xs={12}>
                                       <TextField
                                          fullWidth
                                          label='Company'
                                          name='company'
                                          onChange={handleChange}
                                          value={values.company}
                                          variant='outlined'
                                       />
                                    </Grid>
                                    <Grid item md={6} xs={12}>
                                       <TextField
                                          fullWidth
                                          label='Address'
                                          name='address'
                                          onChange={handleChange}
                                          value={values.address}
                                          variant='outlined'
                                       />
                                    </Grid>
                                    <Grid item md={6} xs={12}>
                                       <TextField
                                          fullWidth
                                          label='Set Discount Value'
                                          name='discountValue'
                                          onChange={handleChange}
                                          select
                                          SelectProps={{ native: true }}
                                          value={values.discountValue}
                                          variant='outlined'
                                       >
                                          {discounts.map(option => (
                                             <option key={option.value} value={option.value}>
                                                {option.label}
                                             </option>
                                          ))}
                                       </TextField>
                                    </Grid>
                                 </Grid>
                              </CardContent>
                              <Divider />
                              <Box
                                 sx={{
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                    p: 2
                                 }}
                              >
                                 <Button color='primary' type='submit' variant='contained'>
                                    Add
                                 </Button>
                              </Box>
                           </Card>
                        </form>
                     </Grid>
                     {/* <Grid item lg={2} md={6} xs={12}></Grid> */}
                  </Grid>
               )}
            </Container>
         </Box>
      </>
   )
}

export default AddCustomer
